import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Popup, Button } from 'next-common-lib';
import i18n from 'i18n';
import { PORTAL_MAIN_URL, WIZARD_STEP } from 'constants/wizardConstants';
import NavigationBar from 'components/Common/NavigationBar';
import * as adminInfoActions from 'redux/ducks/adminInfo/adminInfoDucks';
import * as wizardActions from 'redux/ducks/common/wizardDuck';
import * as homeActions from 'redux/ducks/Home/HomeDucks';
import MainContents from './MainContents';

export const SetupPopup = ({ step, setStep }) => {
  const dispatch = useDispatch();
  const isStart = useSelector(state => state.wizard.isStart);
  const isFinish = useSelector(state => state.adminInfo.isFinish);
  const adminVo = useSelector(state => state.adminInfo.adminVo);
  const home = useSelector(state => state.home);

  const getClassName = () => {
    if (step < WIZARD_STEP.STATUS) return 'step-wizard';
    if (step === WIZARD_STEP.FINISHED) return 'done';
    if (step < WIZARD_STEP.FINISHED) return 'final';
    return 0;
  };

  useEffect(() => {
    if (isFinish) {
      window.location.href = PORTAL_MAIN_URL;
    }
  }, [isFinish]);

  useEffect(() => {
    if (home.isSuccess) {
      setStep(step + 1);
    }
  }, [home.isSuccess]);

  const handleOnClick = () => {
    if (step === WIZARD_STEP.FINISHED) {
      dispatch(adminInfoActions.updateFinishPortalConfig({ ptConfYn: 'Y' }));
    } else if (step === WIZARD_STEP.SETUP_HOME) {
      const value = { compCode: adminVo.compCd, sOrgCode: adminVo.compCd, defaultScreenCode: home.screen };
      dispatch(homeActions.setHomeScreen(value));
    } else {
      setStep(step + 1);
    }
  };

  return (
    <>
      {isStart && (
        <Popup
          isDimed
          isShow={isStart}
          dimedClassName="has-bg"
          componentType="normalPopup"
          className={getClassName()}
          size="lg wizard"
          id="popup2"
          useScroll={false}
          closeFunction={() => {
            dispatch(wizardActions.openQuit());
          }}
          headerComponent={[<NavigationBar step={step} setStep={setStep} />]}
          contentsComponent={[<MainContents step={step} setStep={setStep} />]}
          bottomComponent={[
            <>
              {step < WIZARD_STEP.STATUS && step > WIZARD_STEP.SETUP_JOBTITLE && (
                <Button
                  componentType="normal"
                  className="prev"
                  iconInfo={{ className: 'ic-left', size: 'sm' }}
                  label={i18n.t('BTY_W_T_PREV')}
                  onClick={() => {
                    setStep(step - 1);
                  }}
                />
              )}
              <Button
                componentType="dbIconBtn"
                className="next"
                size="md"
                label={step === WIZARD_STEP.FINISHED ? `${i18n.t('BTY_W_T_GO_MAIN')}` : `${i18n.t('BTY_W_T_NEXT')}`}
                iconInfo={[{}, { className: 'ic-right', size: 'sm' }]}
                onClick={() => {
                  handleOnClick();
                }}
              />
            </>,
          ]}
        />
      )}
    </>
  );
};

// 1. 직급명, 직급코드 입력 최대 5개
// 2. 부서등록 최대 5개

SetupPopup.propTypes = {
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
};
SetupPopup.defaultProps = {};

export default SetupPopup;
